// extracted by mini-css-extract-plugin
export default {"title":"BadgeChrome_title__z3qMX","item":"BadgeChrome_item__lHWaU","error":"BadgeChrome_error__JduUS"};